export default {
  surveyBuilder: {
    farmName: "Nama Peternakan",
    farmerName: "Nama Petani",
    scores: "Skor",
    clearSelection: "Hapus Semua Pilihan",
    addNewSurvey: "Tambahkan Survei Baru",
    surveyTitle: "Judul Survei",
    surveyName: "Nama Survei",
    surveyDescription: "Deskripsi Survei",
    describeSurvey: "Deskripsikan Survei",
    enableScheduling: "Aktifkan Penjadwalan",
    enableSchedulingInfo:
      "Kemampuan untuk menetapkan tanggal atau waktu tertentu untuk penilaian.",
    selectedDate: "Tanggal Dipilih",
    multiStepSurvey: "Survei Langkah Banyak",
    multiStepSurveyDetails:
      "Berdasarkan jumlah pertanyaan dalam satu langkah, semua pertanyaan dalam survei akan dikelompokkan dan ditampilkan dalam langkah-langkah.",
    multiStep: "Langkah Banyak",
    noQuestionEachStep: "Jumlah pertanyaan dalam setiap langkah",
    surveyStatus: "Status Survei",
    surveyStatusDetails:
      "Survei hanya dapat diaktifkan setelah menambahkan pertanyaan. Mengaktifkan survei akan memungkinkan petani untuk memulai pengajuan.",
    selectUsers: "Pilih Pengguna",
    selectUsersDetails:
      "Jika pengguna terpilih dinonaktifkan maka survei akan tersedia untuk semua pengguna. Jika Anda Mengaktifkan pengguna yang dipilih, Anda dapat memilih beberapa pengguna dalam langkah berikutnya.",
    linkWithFarms: "Tautkan dengan Peternakan",
    linkWithFarmsDetails:
      "Jika diaktifkan, survei akan dikaitkan dengan peternakan individual. Jika seorang Petani memiliki beberapa peternakan maka setiap peternakan akan memiliki survei sendiri.",
    enabled: "Diaktifkan",
    disabled: "Dinonaktifkan",
    cancel: "Batal",
    next: "Selanjutnya",
    surveySettings: "Pengaturan Survei",
    selectSurveyUsers: "Pilih Pengguna Survei",
    selectToProceed: "Harap pilih pengguna untuk melanjutkan",
    searchUsers: "Cari Pengguna",
    usersSelected: "Pengguna yang Dipilih",
    conditional: "Kondisional",
    autoConditional: "Auto Kondisional",
    userName: "Nama Pengguna",
    email: "Surel",
    membershipType: "Tipe Keanggotaan",
    membershipValidity: "Validitas Keanggotaan",
    membershipRemainingDays: "Jumlah Hari Tersisa",
    membershipRole: "Peran Anggota",
    accountProgress: "Progress Akun",
    status: "Status",
    active: "Aktif",
    deactivated: "Nonaktif",
    continue: "Lanjutkan",
    resolveNow: "Selesaikan Sekarang",
    questions: "Pertanyaan",
    questionInfo:
      "Teks pertanyaan penilaian yang akan disajikan kepada responden.",
    responses: "Respon",
    deleteSurvey: "Hapus Survei",
    editSurvey: "Edit Survei",
    type: "Tipe",
    typeInfo:
      "Menu dropdown untuk menentukan jenis input yang diperlukan untuk pertanyaan, seperti tombol radio, kotak centang, atau input teks.",
    compulsory: "Wajib",
    createSurvey: "Buat Survei",
    surveyBuilder: "Pembuat Survei",
    surveyList: "Daftar Survei",
    farm: "Peternakan",
    responseDate: "Tanggal Respons",
    viewSurvey: "Lihat Survei",
    question: "Pertanyaan",
    settings: "Pengaturan",
    addQuestion: "Tambahkan Pertanyaan",
    surveysSubmitted: "Survei yang Dikirimkan",
    surveyDetail: "Detail Survei",
    conditionStatus: "Status Kondisi",
    conditionStatusDesc:
      "Pengguna yang sesuai dengan kondisi akan secara otomatis memenuhi syarat untuk survei.",
    endSurvey: "Akhiri Survei",
    publishSurvey: "Publikasikan Survei",
    copy: "Salin",
    view: "Lihat",
    startDate: "Tanggal Mulai",
    endDate: "Tanggal Selesai",
    chooseDate: "Pilih tanggal",
    select: "Pilih",
    addSurveyQuestion: "Tambahkan Pertanyaan Survei",
    editSurveyQuestion: "Edit Pertanyaan Survei",
    questionScore: "Skor Pertanyaan",
    mandatory: "Mandatory",
    yes: "Ya",
    no: "Tidak",
    options: "Opsi",
    typeHere: "Ketik di sini",
    add: "Tambah",
    optionsHint: "Silakan masukkan untuk menambahkan jawaban atau klik Tambah",
    surveyProgress: "Survei sedang berlangsung",
    allResponses: "Ringkasan semua respon",
    responseQuestion: "Respon berdasarkan pertanyaan",
    dateSubmitted: "Tanggal Dikirimkan",
    answer: "Jawaban",
    totalScore: "Total Skor",
    score: "Skor",
    singleSelection: "Pilihan Tunggal",
    multipleSelection: "Pilihan Ganda",
    if: "Jika",
    then: "maka",
    noResponse: "Tidak ada respons",
    noSurveyFound: "Tidak Ada Survei Ditemukan",
    createNewSurvey:
      'Silakan buat survei menggunakan tombol "Buat Survei" di atas',
    cannotPublish: "Tidak dapat mempublikasikan survei yang dinonaktifkan!",
    deleteSurveyWarn:
      "Apakah Anda yakin ingin menghapus survei. Jika Anda menghapusnya, semua pertanyaan survei dan pengajuan akan dihapus secara permanen.",
    noQuestionFound: "Tidak Ada Pertanyaan Ditemukan",
    createQuestion:
      'Harap tambahkan pertanyaan terlebih dahulu menggunakan tombol "TAMBAH PERTANYAAN" di atas',
    deleteQuestion: "Apakah Anda yakin ingin menghapus pertanyaan?",
    applyChanges: "Bagaimana Anda ingin menerapkan perubahan ini?",
    editFutureSurveys: "EDIT HANYA SURVEI YANG AKAN DATANG",
    editLiveSurveyOnly: "HANYA EDIT SURVEI YANG SEDANG BERLANGSUNG",
    surveyIsLive:
      "Harap dicatat bahwa survei saat ini sedang berlangsung, dan mengedit pertanyaan pada saat ini dapat mempengaruhi pengajuan sebelumnya. Untuk menghindari masalah, Anda dapat mempertimbangkan untuk membuat salinan survei untuk membuat perubahan pada pertanyaan.",
    clickToCopy: "Klik di Sini Untuk Membuat Salinan Survei",
    applyChangesNow: "TERAPKAN PERUBAHAN SEKARANG",
    copySurvey: "Salin Survei",
    changeCopySurveyName: "Anda dapat mengubah nama versi survei yang disalin.",
    textField: "Kolom Teks",
    textArea: "Area Teks",
    textFieldNumeric: "Kolom Teks Numerik",
    radioButton: "Tombol Radio",
    checkBoxes: "Kotak Centang",
    dynamicFarmer: "Petani Dinamis",
    dynamicGeofence: "Geofence Dinamis",
    dynamicCrop: "Tanaman Dinamis",
    dynamicEquipment: "Peralatan Dinamis",
    downloadSurvey: "Unduh Survei",
    downloadQuestion: "Unduh Hanya Pertanyaan",
    downloadResponse: "Unduh Semua Respon",
    chooseFileFormat: "Pilih Format File",
    surveyTitleLength: "Judul survei harus kurang dari 100 karakter",
    selectAllFiltered: "Pilih semua yang difilter",
    surveyDownloads: "Unduhan Survei",
    gpsLocation: "Lokasi GPS",
  },
};
